import { Amplify } from "aws-amplify";
import { generateClient } from "aws-amplify/api";

import config from "~/init/aws-exports";

// Configure Amplify lazily - only when this module is first imported
// This avoids loading Amplify on pages that don't use notifications
let configured = false;
const ensureConfigured = () => {
  if (!configured) {
    Amplify.configure(config);
    configured = true;
  }
};

// Singleton GraphQL client for AppSync
// Configuration happens lazily on first import of this module
ensureConfigured();
const appsyncClient = generateClient();

export default appsyncClient;
